// NexoNurse AppAPI client — all authenticated requests go through here.
// REACT_APP_API_URL is injected at CI build time per environment.
// Fallback: derive API origin from the page hostname so the app self-heals
// when the env var is missing (e.g. local build deployed to S3 without CI).
// Token is read from AuthContext via the getToken callback to avoid coupling.

function resolveApiBase() {
  if (process.env.REACT_APP_API_URL) return process.env.REACT_APP_API_URL;
  if (typeof window === 'undefined') return '';
  const host = window.location.hostname;
  if (host === 'app.nexonurse.com') return 'https://api.nexonurse.com';
  if (host === 'dev.nexonurse.com') return 'https://api-dev.nexonurse.com';
  return ''; // localhost — CRA proxy handles /api routing
}

export const API_BASE = resolveApiBase();

/**
 * Authenticated fetch helper.
 * @param {string} path - API path (e.g. '/api/signals')
 * @param {RequestInit} options - fetch options (method, body, etc.)
 * @param {() => string | null | undefined} getToken - callback returning current access token
 */
export async function apiFetch(path, options = {}, getToken) {
  const token = typeof getToken === 'function' ? getToken() : null;

  const res = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(options.headers || {}),
    },
  });

  if (res.status === 401) {
    // Notify AuthContext to clear session and redirect to login
    window.dispatchEvent(new CustomEvent('auth:expired'));
    throw new Error('Session expired — please log in again');
  }

  if (!res.ok) {
    throw new Error(`AppAPI ${res.status}: ${path}`);
  }

  // 204 No Content has no body
  if (res.status === 204) return null;

  return res.json();
}
